<template>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='datalist' :scroll="{ x: true}">
    </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="search.total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
</template>

<script>
import { onMounted, ref } from '@vue/runtime-core';
import {
  get_batch_range_list,
  get_chd_range_list
} from "@/api/guide";
let columns = [
  {
    title: "出库单号",
    dataIndex: "out_warehousing_sn",
    key: "out_warehousing_sn",
  },
  {
    title: "关联小标数量",
    dataIndex: "out_warehousing_real_num",
    key: "out_warehousing_real_num",
  },
];
export default {
  props:{
      activity_id: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },
  setup(props){
    const search=ref({
      limit:10,
      page:1,
      total:0,
      activity_id:""
    })
    const datalist=ref([])
    const initData=async()=>{
        let result=await get_chd_range_list(search.value.activity_id,search.value).then(res=>res.data).catch(error=>error)
        datalist.value=result.data.data
        search.value.total=result.data.total

    }
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(()=>{
      search.value.activity_id=props.activity_id
      initData()
    })

   return{
     columns,
     search,
     pageSizeChange,
     pageCurrentChange,
     datalist
   }
  }
}
</script>